<template>
  <div class="form-field">
    <label>透明度</label>
    <div class="content">
      <el-slider :value="opacity" @input="setOpacity" :show-tooltip="false"/>
      <input class="form-input" type="number" :min="0" :max="100" :step="1" :value="opacity" @input="setOpacity($event.target.value)"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  input{
    width:65px;
  }
  .content{
    display:flex;
    >div{
      flex:1;
      margin-right:10px;
    }
    >input{
      padding:0 10px;
    }
  }
</style>

<script>
  import style from 'mixins/style'

  export default {
    mixins: [ style ],
    computed: {
      style() {
        return this.$store.state.mask && this.$store.state.mask[ 0 ] && this.$store.state.mask[ 0 ].style || {}
      },
      opacity(){
        if(typeof this.style.opacity === 'string'&&this.style.opacity === ''){
          return 100
        }else{
          return parseInt(typeof this.style.opacity!=='undefined'?parseFloat(this.style.opacity)*100:100)
        }
      }
    },
    methods:{
      setOpacity(value){
        if((this.opacity+'')!==(value+'')){
          this.updateStyle('opacity', value/100)
        }
      }
    }
  }
</script>
